export default class RequiredValidator {

  static validate(questionKind, fieldValue) {
    if (questionKind === 'text_field' && fieldValue === '') { return false }
    if (questionKind === 'integer_field' && fieldValue === '') { return false }
    if (questionKind === 'gender' && fieldValue === null) { return false }
    if (questionKind === 'boolean' && fieldValue === null) { return false }
    if (questionKind === 'radio' && fieldValue === null) { return false }
    if (questionKind === 'check' && fieldValue === '') { return false }
    if (questionKind === 'check_with_others_option' && fieldValue.value.length === 0) { return false }
    if (questionKind === 'boolean_with_complementary_options_on_false' && fieldValue.value == null) { return false }
    if (questionKind === 'radio_with_others_option' && fieldValue.value == null) { return false }

    return true
  }

}
